import React from "react";
import { ProjectIndeterminateCheckbox } from "../partials/ProjectsTable/components/ProjectIndeterminateCheckbox";

export const generateColumns = (
  columns = [],
  hiddenColumns = [],
  customNameHeader = null,
) => {
  const filteredColumns = columns.filter(
    (c) => !hiddenColumns.includes(c.uuid),
  );
  return [
    {
      accessor: "selection",
      Footer: "",
      sticky: "left",
      width: 10,
      Header: (props) => <> </>,
      Cell: (props) => <ProjectIndeterminateCheckbox data={props} />,
    },
    {
      Header: customNameHeader || "NAME",
      accessor: "projectName",
      Footer: "Name",
      sticky: "left",
      width: 375,
    },
    ...filteredColumns.map((c) => ({
      accessor: c.uuid,
      Header: c.name,
      origin: c.origin,
      width: "auto",
    })),

    ...(filteredColumns.length === 0
      ? [
          {
            Header: " ",
            accessor: "7512ab25-6c6d-4339-b831-0260e5d8a149",
            Footer: " 7512ab25-6c6d-4339-b831-0260e5d8a149",
            width: "auto",
          },
          {
            Header: " action",
            accessor: "projectAction",
            Footer: " action",
            sticky: "right",
            width: 88,
          },
        ]
      : [
          {
            Header: " action",
            accessor: "projectAction",
            Footer: " action",
            sticky: "right",
            width: 88,
          },
        ]),
  ];
};
